import React, { startTransition, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Frames, CardNumber, ExpiryDate, Cvv } from "frames-react";
import PaymentsWrapper from "../PaymentGateway.style";
import propTypes from "prop-types";
import CardTypesIcon from "../Icons/cards-types.svg";
import CardIcon from "../Icons/Input-Card-Icon.svg";
import CalendarIcon from "../Icons/Input-Calendar-Icon.svg";
import LockIcon from "../Icons/Input-Lock-Icon.svg";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import {
  BUSINESS_LINE_COLORS,
  BUSINESS_LINE_PATHS,
} from "../../../helpers/utils";

function CreditCard(props) {
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(props.creditCardLoading);
  const { businessLine } = useSelector((state) => state.travel);

  const payNow = () => {
    startTransition(() => {
      setLoading(true);
      Frames.submitCard();
    });
  };

  useEffect(() => {
    setLoading(props.creditCardLoading);
  }, [props.creditCardLoading]);

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.STC)
    businessColor = BUSINESS_LINE_COLORS.STC;

  return (
    <PaymentsWrapper businessColor={businessColor} className="p-md-3">
      <Frames
        config={{
          publicKey: process.env.REACT_APP_CHECKOUT_KEY,
          localization: {
            cardNumberPlaceholder: props.i18n.t("common.card-number"),
            expiryMonthPlaceholder: `${props.i18n.t("common.mm")}`,
            expiryYearPlaceholder: `${props.i18n.t("common.yy")}`,
            cvvPlaceholder: `${props.i18n.t("common.cvv")}`,
          },
          style: {
            base: {
              fontSize: "17px",
            },
          },
        }}
        ready={() => {}}
        frameActivated={(e) => {}}
        // frameFocus={(e) => { console.log("frameFocus : ", e) }}
        // frameBlur={(e) => { console.log("Blur : ", e)}}
        frameValidationChanged={(e) => {}}
        paymentMethodChanged={(e) => {}}
        cardValidationChanged={(e) => {
          setIsValid(e.isValid);
        }}
        cardSubmitted={() => {}}
        cardTokenized={(e) => {
          console.log(e);
          props.creditCardToken(e.token);
        }}
        cardTokenizationFailed={(e) => {}}
        // cardBinChanged={(e) => {  console.log("cardBinChanged : " , e);}}
      >
        <div className="row">
          <div
            className={
              businessLine
                ? `left-col-${businessLine} left-col col-md-6 mx-auto mb-4`
                : "left-col col-md-6 mx-auto mb-4"
            }
            style={{ textAlign: "left" }}
          >
            <div className="accepted-cards-wrapper">
              <h5 className="mb-3">{props.i18n.t("common.following-cards")}</h5>
              <img src={CardTypesIcon} alt="Accepted Cards" height="32px" />
            </div>
          </div>
          <div
            className={
              businessLine
                ? `right-col-${businessLine} right-col col-md-6 mx-auto mb-4`
                : "right-col col-md-6 mx-auto mb-4"
            }
          >
            <h6 className="card-form-title text-initial">
              {props.i18n.t("common.fill-card-info")}
            </h6>
            <div className="mb-2">
              <span className="p-input-icon-right w-100">
                <i className="pw_custom_icon card-number">
                  <img src={CardIcon} alt="Card Icon" />
                </i>
                <CardNumber style={{ background: "#FFF" }} />
              </span>
            </div>
            <div className="d-flex mb-4">
              <span
                className={
                  "p-input-icon-right w-50 " +
                  (props.i18n.language === "ar" ? "ms-4" : "me-4")
                }
              >
                <i className="pw_custom_icon">
                  <img src={CalendarIcon} alt="Calendar Icon" />
                </i>
                <ExpiryDate style={{ background: "#FFF" }} />
              </span>
              <span className="p-input-icon-right w-50">
                {/* <i className="pi pi-lock"></i> */}
                <i className="pw_custom_icon">
                  <img src={LockIcon} alt="Lock Icon" />
                </i>
                <Cvv style={{ background: "#FFF" }} />
              </span>
            </div>
            <Button
              onClick={() => payNow()}
              loading={loading}
              disabled={!isValid || !props.acknowledgeAgree}
              type="Button"
              className="btn primary next text-uppercase px-3"
              style={{ background: businessColor }}
            >
              {props.i18n.t("common.pay-now")}
            </Button>
            {/* <div className="d-inline-flex">
              <InputSwitch
                id="save-card-switch"
                className="me-2"
                checked={saveCard}
                onChange={(e) => updateSaveCard(e.value)}
              />{" "}
              <label htmlFor="save-card-switch">
                Save card for future checkouts
              </label>
            </div> */}
          </div>
        </div>
      </Frames>
    </PaymentsWrapper>
  );
}

CreditCard.propTypes = propTypes.exact({
  creditCardToken: propTypes.func.isRequired,
  creditCardLoading: propTypes.bool.isRequired,
  acknowledgeAgree: propTypes.bool.isRequired,
}).isRequired;

export default withTranslation()(CreditCard);
